import { render, staticRenderFns } from "./saleOrderPickers.vue?vue&type=template&id=1624d553&scoped=true"
import script from "./saleOrderPickers.vue?vue&type=script&lang=js"
export * from "./saleOrderPickers.vue?vue&type=script&lang=js"
import style0 from "./saleOrderPickers.vue?vue&type=style&index=0&id=1624d553&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1624d553",
  null
  
)

export default component.exports